import { render } from "./HomeProductsSection.vue?vue&type=template&id=ca7b6e38&scoped=true"
import script from "./HomeProductsSection.vue?vue&type=script&lang=js"
export * from "./HomeProductsSection.vue?vue&type=script&lang=js"

import "./HomeProductsSection.vue?vue&type=style&index=0&id=ca7b6e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7b6e38"]])

export default __exports__